import { render } from "./DataTablePanel.vue?vue&type=template&id=d8f89d58&scoped=true"
import script from "./DataTablePanel.vue?vue&type=script&lang=js"
export * from "./DataTablePanel.vue?vue&type=script&lang=js"

import "./DataTablePanel.vue?vue&type=style&index=0&id=d8f89d58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_96a7004b96defd358d2378707b0c7ba6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f89d58"]])

export default __exports__